<div class="event" [style.border-left]="'5px solid ' + Event()?.EventColor"
    (click)="openEventDetails()"
    style="cursor: pointer;"
>
    <div>
        {{localEventStart() | date: 'HH:mm'}}
    </div>
        <div>{{Event()?.Title}}<br>
                          <span>{{Event()?.LastName}}, {{Event()?.FirstName}}</span>
                        </div>
</div>  
